import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";
import { down } from "../../styles/breakpoints";

const useStyles = createUseStyles((_) => ({
  container: {
    width: "100%",
    /* `--app-height` resolves to 100dvh where supported. With a flat 100vh,
       mobile Safari counts the collapsed URL bar, so the sign-in button sat
       under the browser chrome until the user scrolled. */
    minHeight: "var(--app-height)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    /* Breathing room so the card never touches the screen edge, plus the iOS
       safe-area inset for notched devices. */
    padding: "32px 20px",
    paddingTop: "max(32px, env(safe-area-inset-top))",
    paddingBottom: "max(32px, env(safe-area-inset-bottom))",
    backgroundColor: colors.secondary,
  },

  logo: {
    width: "min(226px, 70%)",
    height: "auto",
    maxHeight: "130px",
    objectFit: "contain",
  },

  /* A flat `width: 350px` overflowed every phone narrower than 350px plus
     padding — the form was horizontally clipped on an iPhone SE. */
  subContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    width: "100%",
    maxWidth: "350px",
    marginTop: "36px",
    [down.sm]: {
      marginTop: "24px",
    },
  },
  customLabel: {
    margin: "9px 16px",
    "& .MuiTypography-root": {
      color: colors.WHITE,
      fontFamily: "Poppins-Regular",
      fontSize: 13,
    },
  },
  customCheckbox: {
    "& .MuiSvgIcon-root": {
      fontSize: 13,
      color: colors.WHITE,
    },
  },
  forgotPassword: {
    textAlign: "center",
  },
}));

export default useStyles;
